<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> ثبت درخواست والدین </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- اطلاعات دریافت شده -->

    <div class="mt-2 p-2" style="height:calc(100vh - 92px);overflow: auto;">

        <div class="container d-flex justify-content-center w-100">

            <div [formGroup]="mdl_Request" class="row justify-content-center gx-0 gy-3 py-3 m-0 border rounded">

                <!-- کد ملی -->

                <form class="col-12 row justify-content-center gx-0 gy-0 p-0 my-3" [formGroup]="mdl_Search">

                    <div class="col-8 p-1">

                        <div class="w-100 h-100">

                            <input type="text" class="w-100 form-control" placeholder="کد ملی دانش آموز" formControlName="strNationalCode" oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()" maxlength="10">

                        </div>

                    </div>

                    <!-- جستجو -->

                    <div class="col-2 p-1">

                        <div class="w-100 h-100">

                            <button class="btn btn-primary w-100" (click)="getStudent()">

                                جستجو

                            </button>

                        </div>

                    </div>

                </form>

                <!-- دانش آموز -->

                <div class="col-5 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> دانش آموز </label>

                        <input class="form-control p-2 text-center" formControlName="strPassenger_FullName" disabled>

                    </div>

                </div>

                <!-- موبایل -->

                <div class="col-5 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> موبایل </label>

                        <input class="form-control p-2 text-center" formControlName="strMobile" disabled>

                    </div>

                </div>

                <!-- شهر -->

                <div class="col-5 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> شهر </label>

                        <input class="form-control p-2 text-center" formControlName="strCityName" disabled>

                    </div>

                </div>

                <!-- مدرسه -->

                <div class="col-5 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> مدرسه </label>

                        <input class="form-control p-2 text-center" formControlName="strMobileDomain_strComment" disabled>

                    </div>

                </div>

                <!-- نوع مدرسه -->

                <div class="col-5 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> نوع مدرسه </label>

                        <input class="form-control p-2 text-center" formControlName="strSchoolType_strComment" disabled>

                    </div>

                </div>

                <!-- جنسیت -->

                <div class="col-5 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> جنسیت </label>

                        <input class="form-control p-2 text-center" formControlName="strSex_strSexComment" disabled>

                    </div>

                </div>

                <!-- مقطع -->

                <div class="col-5 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> مقطع </label>

                        <input class="form-control p-2 text-center" formControlName="strEducationLevel_strComment" disabled>

                    </div>

                </div>

                <!-- پایه -->

                <div class="col-5 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> پایه </label>

                        <input class="form-control p-2 text-center" formControlName="strGrade" disabled>

                    </div>

                </div>

                <!-- موضوع -->

                <div class="col-10 p-1">

                    <div class="position-relative w-100 h-100">

                        <custom-filter  
    
                            [strValue]="returnStrValue('tiMadonik_RequestType',mdl_Request.get('tiMadonik_RequestType')?.value,lst_RequestType,'strComment')"

                            [strComment]="'strComment'" 
                            
                            [stylesArray]="['padding-top: 10px']" 
                            
                            [str_Placeholder]="'موضوع را جستجو کنید'"

                            [lst_Main]="lst_RequestType" 
                            
                            [lst_SearchKey]="['strComment']" 
                            
                            [isDisabled]="false"

                            (hideOptions)="submitValue2($event)">

                        </custom-filter>

                    </div>

                </div>

                <!-- توضیحات -->

                <div class="col-10 p-1">

                    <div class="position-relative w-100 h-100">

                        <label class="mb-2 text-muted"> توضیحات </label>

                        <textarea style="height: 75px;resize: none;" class="form-control" formControlName="strDetail"></textarea>

                    </div>

                </div>

                <!-- ذخیره -->

                <div class="col-10 p-1">

                    <div class="w-100 h-100">

                        <button class="btn btn-success" (click)="submitRequest()" [disabled]="mdl_Request.get('iPassenger')?.value == ''"> 

                            ثبت درخواست
                            
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

</main>